import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() => client.GET('/posology/{id}', { params: { path: { id } } }))
  },

  async list(query?: ApiSchemas['ListPosologyDto']) {
    return wrapEndpoint(() => client.GET('/posology', { params: { query } }))
  },

  async create(body: ApiSchemas['CreatePosologyDto']) {
    return wrapEndpoint(() => client.POST('/posology', { body }))
  },

  async update(id: number, body: ApiSchemas['UpdatePosologyDto']) {
    return wrapEndpoint(() => client.PUT('/posology/{id}', { body, params: { path: { id } } }))
  },

  async delete(id: number) {
    await wrapEndpoint(() => client.DELETE('/posology/{id}', { params: { path: { id } } }))
  },
}
